import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface WebStatus {
  webStatusId: number;
  customersCount: number;
  transactionsAmount: number;
  transactionsCount: number;
  status: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class WebStatusService {
  private apiUrl = 'https://pos.qootk.com/api/ZOut/webStatus';

  constructor(private http: HttpClient) { }

  getWebStatus(): Observable<WebStatus> {
    return this.http.get<WebStatus>(this.apiUrl);
  }
}
